import { render, staticRenderFns } from "./render-button-group.vue?vue&type=template&id=82b187e0&scoped=true"
import script from "./render-button-group.vue?vue&type=script&lang=js"
export * from "./render-button-group.vue?vue&type=script&lang=js"
import style0 from "./render-button-group.vue?vue&type=style&index=0&id=82b187e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b187e0",
  null
  
)

export default component.exports